var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _vm.reservation
            ? _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "pa-0" },
                    [
                      _c(
                        "v-card-actions",
                        {
                          staticClass: "no-print",
                          staticStyle: { "background-color": "#f5f5f5" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "d-none d-md-flex",
                              attrs: {
                                title: "View this member's details",
                                target: "_blank",
                                href: _vm.viewClientUrl,
                              },
                            },
                            [_c("v-icon", [_vm._v("person")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "d-none d-md-flex",
                              attrs: {
                                title: "Email the client directly",
                                target: "_blank",
                                href: _vm.emailClientUrl,
                              },
                            },
                            [_c("v-icon", [_vm._v("email")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                title: "Phone the client directly",
                                href: _vm.phoneClientUrl,
                              },
                            },
                            [_c("v-icon", [_vm._v("phone")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "d-none d-md-flex",
                              attrs: {
                                title: "Log in as the client",
                                target: "_blank",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.logInAsClient(_vm.reservation)
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("web")])],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "d-none d-md-flex",
                              attrs: {
                                title:
                                  "View the property's overview page on the booking site",
                                target: "_blank",
                                href: _vm.overviewUrl,
                              },
                            },
                            [_c("v-icon", [_vm._v("web")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "d-none d-md-flex",
                              attrs: {
                                title:
                                  "Email the property's reservations department",
                                target: "_blank",
                                href: _vm.emailHotelUrl,
                              },
                            },
                            [_c("v-icon", [_vm._v("email")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                title:
                                  "Phone the property's reservations department",
                                target: "_blank",
                                href: _vm.phoneHotelUrl,
                              },
                            },
                            [_c("v-icon", [_vm._v("phone")])],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "d-none d-md-flex",
                              attrs: {
                                title: "View the property's room types",
                                target: "_blank",
                                href: _vm.roomTypesUrl,
                              },
                            },
                            [_c("v-icon", [_vm._v("hotel")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "d-none d-md-flex",
                              attrs: {
                                title: "View the property's rate types",
                                target: "_blank",
                                href: _vm.rateTypesUrl,
                              },
                            },
                            [_c("v-icon", [_vm._v("money")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "d-none d-md-flex",
                              attrs: {
                                title:
                                  "View the property's ARI on its daily planner",
                                target: "_blank",
                                href: _vm.plannerUrl,
                              },
                            },
                            [_c("v-icon", [_vm._v("calendar_today")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "d-none d-md-flex",
                              attrs: {
                                title: "View the property's special offers",
                                target: "_blank",
                                href: _vm.specialOffersUrl,
                              },
                            },
                            [_c("v-icon", [_vm._v("local_offer")])],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "d-none d-md-flex",
                              attrs: {
                                title:
                                  "Change the stay dates for this reservation",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.setTask("changeDates")
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("edit_calendar")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "d-none d-md-flex",
                              attrs: {
                                title:
                                  "Change the rooms and rates for this reservation",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.setTask("changeRoomsAndRates")
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("hotel")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "d-none d-md-flex",
                              attrs: {
                                title: "Change the quote for this reservation",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.setTask("changePrices")
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("paid")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "d-none d-md-flex",
                              attrs: {
                                title: "Change the status of this reservation",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.setTask("changeStatus")
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("crop_7_5")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "d-none d-md-flex",
                              attrs: {
                                title:
                                  "Change the fees and taxes charged for this reservation",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.setTask("changeFees")
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("paid")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "d-none d-md-flex",
                              attrs: {
                                title:
                                  "Open the reservation for direct editing",
                                target: "_blank",
                                href: _vm.editUrl,
                              },
                            },
                            [_c("v-icon", [_vm._v("edit")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "d-none d-md-flex",
                              attrs: { title: "Void the reservation" },
                              on: {
                                click: function ($event) {
                                  return _vm.voidReservation(_vm.reservation)
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("delete")])],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "d-none d-md-flex",
                              attrs: {
                                title:
                                  "Resend the messages for the current reservation status",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.resendNotifications(
                                    _vm.reservation
                                  )
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("email")])],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        [
                          1 || _vm.reservation.show
                            ? _c(
                                "v-container",
                                { staticClass: "pa-0", attrs: { fluid: "" } },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "pa-0",
                                          attrs: { cols: "12", md: "4" },
                                        },
                                        [
                                          _c(
                                            "ies-reservation-administration-overview",
                                            {
                                              attrs: {
                                                reservationkey:
                                                  _vm.reservation
                                                    .reservation_key,
                                              },
                                            }
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "ies-reservation-administration-notes",
                                            {
                                              attrs: {
                                                reservationkey:
                                                  _vm.reservation
                                                    .reservation_key,
                                              },
                                            }
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.task == "changeDates"
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "pa-0",
                                              attrs: { cols: "12", md: "8" },
                                            },
                                            [
                                              _c(
                                                "ies-reservation-administration-change-dates",
                                                {
                                                  attrs: {
                                                    reservationkey:
                                                      _vm.reservation
                                                        .reservation_key,
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.task == "changeRoomsAndRates"
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "pa-0",
                                              attrs: { cols: "12", md: "8" },
                                            },
                                            [
                                              _c(
                                                "ies-reservation-administration-change-rooms-rates",
                                                {
                                                  attrs: {
                                                    reservationkey:
                                                      _vm.reservation
                                                        .reservation_key,
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.task == "changePrices"
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "pa-0",
                                              attrs: { cols: "12", md: "8" },
                                            },
                                            [
                                              _c(
                                                "ies-reservation-administration-change-prices",
                                                {
                                                  attrs: {
                                                    reservationkey:
                                                      _vm.reservation
                                                        .reservation_key,
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.task == "changeStatus"
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "pa-0",
                                              attrs: { cols: "12", md: "8" },
                                            },
                                            [
                                              _c(
                                                "ies-reservation-administration-change-status",
                                                {
                                                  attrs: {
                                                    reservationkey:
                                                      _vm.reservation
                                                        .reservation_key,
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.task == "changeFees"
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "pa-0",
                                              attrs: { cols: "12", md: "8" },
                                            },
                                            [
                                              _c(
                                                "ies-reservation-administration-change-fees",
                                                {
                                                  attrs: {
                                                    reservationkey:
                                                      _vm.reservation
                                                        .reservation_key,
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      (_vm.reservation.status_key == 8 ||
                                        _vm.reservation.status_key == 10) &&
                                      _vm.task == "manage reservation"
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "pa-0",
                                              attrs: { cols: "12", md: "8" },
                                            },
                                            [
                                              _c(
                                                "ies-reservation-administration-enquiry",
                                                {
                                                  attrs: {
                                                    reservationkey:
                                                      _vm.reservation
                                                        .reservation_key,
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.reservation.status_key == 12 &&
                                      _vm.task == "manage reservation"
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "pa-0",
                                              attrs: { cols: "12", md: "8" },
                                            },
                                            [
                                              _c(
                                                "ies-reservation-administration-confirmed",
                                                {
                                                  attrs: {
                                                    reservationkey:
                                                      _vm.reservation
                                                        .reservation_key,
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      (_vm.reservation.status_key == 11 ||
                                        _vm.reservation.status_key == 20) &&
                                      _vm.task == "manage reservation"
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "pa-0",
                                              attrs: { cols: "12", md: "8" },
                                            },
                                            [
                                              _c(
                                                "ies-reservation-administration-awaiting",
                                                {
                                                  attrs: {
                                                    reservationkey:
                                                      _vm.reservation
                                                        .reservation_key,
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.reservation.status_key == 17 &&
                                      _vm.task == "manage reservation"
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "pa-0",
                                              attrs: { cols: "12", md: "8" },
                                            },
                                            [
                                              _c(
                                                "ies-reservation-administration-cancellation",
                                                {
                                                  attrs: {
                                                    reservationkey:
                                                      _vm.reservation
                                                        .reservation_key,
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.reservation.status_key == 18 &&
                                      _vm.task == "manage reservation"
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "pa-0",
                                              attrs: { cols: "12", md: "8" },
                                            },
                                            [
                                              _c(
                                                "ies-reservation-administration-cancelled",
                                                {
                                                  attrs: {
                                                    reservationkey:
                                                      _vm.reservation
                                                        .reservation_key,
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.reservation.status_key == 15 &&
                                      _vm.task == "manage reservation"
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "pa-0",
                                              attrs: { cols: "12", md: "8" },
                                            },
                                            [
                                              _c(
                                                "ies-reservation-administration-declined",
                                                {
                                                  attrs: {
                                                    reservationkey:
                                                      _vm.reservation
                                                        .reservation_key,
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.reservation.status_key == 13 &&
                                      _vm.task == "manage reservation"
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "pa-0",
                                              attrs: { cols: "12", md: "8" },
                                            },
                                            [
                                              _c(
                                                "ies-reservation-administration-accepted",
                                                {
                                                  attrs: {
                                                    reservationkey:
                                                      _vm.reservation
                                                        .reservation_key,
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.reservation.status_key == 9 &&
                                      _vm.task == "manage reservation"
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "pa-0",
                                              attrs: { cols: "12", md: "8" },
                                            },
                                            [
                                              _c(
                                                "ies-reservation-administration-completed",
                                                {
                                                  attrs: {
                                                    reservationkey:
                                                      _vm.reservation
                                                        .reservation_key,
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "pa-0",
                                          attrs: { cols: "12" },
                                        },
                                        [
                                          _c(
                                            "ies-reservation-administration-messages",
                                            {
                                              attrs: {
                                                reservationkey:
                                                  _vm.reservation
                                                    .reservation_key,
                                              },
                                            }
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }